import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../../Componments/Frontend/const';
import InventorySmItem from '../../Componments/Frontend/Srp/InventorySmItem';
import InventoryMdItem from '../../Componments/Frontend/Srp/InventoryMdItem';
const carData = [
    {
        image: 'fv-img1.jpg',
        title: '2024 Audi S5 Cabriolet',
        price: '$64,995',
        mileage: '575mi',
    },
    {
        image: 'fv-img2.jpg',
        title: '2023 Bentley Bentayga',
        price: '$199,995',
        mileage: '3,767mi',
    },
    {
        image: 'fv-img3.jpg',
        title: '2016 Bentley Continental GT',
        price: '$109,995',
        mileage: '11,682mi',
    },
    {
        image: 'featured.webp',
        title: '2023 Ferrari Spider GT',
        price: '$199,995',
        mileage: '575mi',
        content: 'This one of a kind machine clocks 0 - 60 in 4.5 seconds only one previous owner and only 600 have ever been made.',
        LatestDrop: 'true'
    },
    {
        image: 'fv-img4.jpg',
        title: '1969 Chevrolet Camaro SS',
        price: '$69,995',
        mileage: '7,194mi',
    },
    {
        image: 'fv-img5.jpg',
        title: '2023 Bentley Bentayga',
        price: '$199,995',
        mileage: '3,767mi',
    },
    {
        image: 'srp-img7.webp',
        title: '2024 Lamborghini Urus',
        price: '$299,995',
        mileage: '200mi',
    },
    {
        image: 'srp-img9.webp',
        title: '2019 Chevrolet Corvette',
        price: '$99,995',
        mileage: '3,026mi',
    },
    {
        image: 'srp-img10.webp',
        title: '2021 Chevrolet Corvette',
        price: '$71,995',
        mileage: '8,030mi',
    },
    {
        image: 'fv-img5.jpg',
        title: '2018 Ford Mustang',
        price: '$21,995',
        mileage: '43,754mi',
    },
]
const Srp = () => {
    const [isSticky, setIsSticky] = useState(false);
    const [srpFilter, setSrpFilter] = useState(false);
    const handelSrpFilter = () => {
        setSrpFilter(true)
    }
    const closeSrpFilter = () => {
        setSrpFilter(false)
    }
    // const { getVehicleData, filteredVehicleData, setSearchText, numberFormatter, currentFilterData, setCurrentFilterData, activeFilter, setActiveFilter } = useContext("");
    const [timer, setTimer] = useState(null);
    const [vehicleSearchText, setVehicleSearchText] = useState("");
    const searchInputChanged = (val) => {

        setVehicleSearchText(val);

        clearTimeout(timer);

        const newTimer = setTimeout(() => {
            // setSearchText(val);
        }, 500)

        setTimer(newTimer)
    }

    useEffect(() => {

        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [openFilterModal, setOpenFilterModal] = useState(false);

    const [filterData, setFilterData] = useState([]);

    const handleFilterModal = (field) => {
        setOpenFilterModal(true);

        // setFilterData(currentFilterData[field]);

        // setActiveFilter(field);
    }

    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }
  return (
    <>
        <section className='srp-wrap py-5'>
            <div className='srp-wrap-block'>
                <section className='srp-top-block'>
                    <div className='container'>
                        <div className='d-flex mb-4 align-items-center justify-content-between'>
                            <div className='md-title fw-700 wow fadeInDown' data-wow-delay="0.2s">Search Results</div>
                            <div className='d-lg-none'>
                                <button type='button' className='filter-btn' onClick={handelSrpFilter}>Filter <img src={getImages('filter_icon.svg')} alt='icon' /></button>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="srpFilter" className={`product-block ${isSticky ? 'sticky' : ''}`}>
                    <div className='srp-filter-block'>
                        <div className='container'>
                            <div className='row align-items-center'>
                                <div className='col-md-4'>
                                    <div className='d-flex align-items-center'>
                                        <div className='d-flex search-box'>
                                            <input type='text' className='form-control'
                                                placeholder='Search'
                                                value={vehicleSearchText}
                                                onChange={(e) => { searchInputChanged(e.target.value) }}
                                            />
                                            <button className='search-icon'></button>
                                        </div>
                                        <div className='d-lg-none sticky-filter-btn'>
                                            <button type='button' className='filter-btn' onClick={handelSrpFilter}>Filter <img src={getImages('filter_icon.svg')} alt='icon' /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-md-8 text-end srp-filter-blk ${srpFilter ? "active" : ""}`}>
                                    <div className='srp-filter-header d-lg-none'>
                                        <div>Filters</div>
                                        <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('close-anticon.svg')} /></button>
                                    </div>
                                    <div className='srp-filter-body d-inline-flex gap-3'>
                                        <div className='d-lg-none mb-4'>
                                            <div className='sm-title text-start'>Applied Filters</div>
                                            <div className='mt-3 text-start'>
                                                <span className='sf-tag me-2'>2023 <img src={getImages('cross_icon.svg')} /></span>
                                                <span className='sf-tag me-2'>Porsche <img src={getImages('cross_icon.svg')} /></span>
                                            </div>
                                        </div>
                                        <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('year')}>
                                            <span className='srfb-icon'><img src={getImages('year-icon.webp')} alt='icon' /></span>
                                            <span>Year</span>
                                            <span className='srp-fl-arrow'></span>
                                        </button>
                                        <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('make')}>
                                            <span className='srfb-icon'><img src={getImages('make-icon.webp')} alt='icon' /></span>
                                            <span>Make</span>
                                            <span className='srp-fl-arrow'></span>
                                        </button>
                                        <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('model')}>
                                            <span className='srfb-icon'><img src={getImages('model-icon.webp')} alt='icon' /></span>
                                            <span>Model</span>
                                            <span className='srp-fl-arrow'></span>
                                        </button>
                                        <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('trim')}>
                                            <span className='srfb-icon'><img src={getImages('trim-icon.webp')} alt='icon' /></span>
                                            <span>Trim</span>
                                            <span className='srp-fl-arrow'></span>
                                        </button>
                                        <button className='srp-filter-btn' type='button' onClick={() => handleFilterModal('more')}>
                                            <span className='srfb-icon'><img src={getImages('more-icon.webp')} alt='icon' /></span>
                                            <span>More</span>
                                            <span className='srp-fl-arrow'></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='container'>
                        <div className='srp-list'>
                            <div className='row'>
                                {carData.map((car, index) => 
                                    car.LatestDrop ? (
                                        <InventoryMdItem
                                            car={car}
                                            index={index}
                                            key={index}
                                        />
                                    ) : (
                                        <InventorySmItem
                                            car={car}
                                            index={index}
                                            key={index}
                                        />
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </>
  )
}

export default Srp